import { DEFAULT_DASHBOARD_SETTINGS } from '@bms/common';
import type { FlavourFeatures } from './types';

export const residentialFeatures: FlavourFeatures = {
  hasAccessControl: false,
  hasDashboard: false,
  hasScenes: true,
  hasDND: false,
  hasMUR: false,
  hasOccupancy: false,
  hasHousekeeping: false,
  hasEnergyMeters: false,
  roomCardVariant: 'detailed',
  dashboardLayout: 'none',
  dashboardHierarchy: { ...DEFAULT_DASHBOARD_SETTINGS, hierarchyLayout: 'grouped' },
};
